import { Action, RequestAccountType } from '../../types/Types';
import ActionTypes from '../Action.types';

type State = {
  requests: RequestAccountType[];
  isLoading: boolean;
};

export const RequestAccountsReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionTypes.start:
      return { ...state, isLoading: true };
    case ActionTypes.find:
      return { ...state, isLoading: false, requests: action.payload };
    case ActionTypes.create:
      return {
        ...state,
        isLoading: false,
        requests: [...state.requests, action.payload],
      };
    case ActionTypes.update:
      return {
        ...state,
        isLoading: false,
        requests: state.requests.map((req) =>
          req._id === action.payload._id ? { ...action.payload } : req
        ),
      };
    case ActionTypes.delete:
      return {
        ...state,
        isLoading: false,
        requests: state.requests.filter(
          (request) => request._id !== action.payload
        ),
      };

    case ActionTypes.error:
      return { ...state, isLoading: false };
    case ActionTypes.clear:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};
